import emailjs from '@emailjs/browser';

// EmailJS Configuration
// TODO: Replace these with your actual EmailJS credentials
// Get them from: https://dashboard.emailjs.com/
const EMAILJS_SERVICE_ID = 'service_1b9k35a'; // e.g., 'service_abc123'
const EMAILJS_TEMPLATE_ID = 'template_lcdjpfo'; // e.g., 'template_xyz789'
const EMAILJS_PUBLIC_KEY = 'k7eBtN1fL2T0-AxnV'; // e.g., 'user_ABC123XYZ'

/**
 * Send email using EmailJS
 * @param {Object} formData - The form data to send
 * @param {string} formData.name - Sender's name
 * @param {string} formData.email - Sender's email
 * @param {string} formData.subject - Email subject
 * @param {string} formData.message - Email message
 * @returns {Promise} - Promise that resolves when email is sent
 */
export const sendEmail = async (formData) => {
    try {
        // Prepare template parameters
        const templateParams = {
            // from_name: formData.name,
            name: formData.name,
            // from_email: formData.email,
            email: formData.email,
            // subject: formData.subject,
            title: formData.subject,

            message: formData.message,
            to_name: 'Babatunde Adenowo', // Your name
            time: new Date().toLocaleString(),
        };

        // Send email using EmailJS
        const response = await emailjs.send(
            EMAILJS_SERVICE_ID,
            EMAILJS_TEMPLATE_ID,
            templateParams,
            EMAILJS_PUBLIC_KEY
        );

        return {
            success: true,
            message: 'Email sent successfully!',
            response,
        };
    } catch (error) {
        console.error('EmailJS Error:', error);
        return {
            success: false,
            message: error.text || 'Failed to send email. Please try again.',
            error,
        };
    }
};

// Initialize EmailJS (optional, but recommended)
export const initEmailJS = () => {
    emailjs.init(EMAILJS_PUBLIC_KEY);
};
